var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{attrs:{"items":_vm.crumbs,"divider":">"}})
}
var staticRenderFns = []

export { render, staticRenderFns }